import { z } from "zod";
import { zArr, zNullable, zNum, zObj, zStr } from "./zodWrapper.js";
import { ZDate } from "./ZDate.js";
export const BunkerReportGetArgs = zObj({ plantId: zNum(), timestampGte: ZDate, timestampLt: ZDate });
export var BunkerReportFuelType;
(function (BunkerReportFuelType) {
    BunkerReportFuelType["HFO"] = "HFO";
    BunkerReportFuelType["LFO"] = "LFO";
    BunkerReportFuelType["MGO"] = "MGO";
    BunkerReportFuelType["LPG"] = "LPG";
    BunkerReportFuelType["LNG"] = "LNG";
    BunkerReportFuelType["Methanol"] = "Methanol";
    BunkerReportFuelType["Ethanol"] = "Ethanol";
    BunkerReportFuelType["Other"] = "Other";
})(BunkerReportFuelType || (BunkerReportFuelType = {}));
export const BunkerReportFuelTypeEnum = z.nativeEnum(BunkerReportFuelType);
export const BunkerReportEntry = zObj({
    bunkerDeliveryNoteNo: zStr(),
    dateUTC: ZDate,
    fuelType: BunkerReportFuelTypeEnum,
    massMT: zNum(),
    densityAt15degree: zNullable(zNum()),
    sulphurContent: zNullable(zNum()),
    viscosity: zNullable(zNum()),
    waterContent: zNullable(zNum()),
    higherHeatingValue: zNullable(zNum()),
    lowerHeatingValue: zNullable(zNum()),
    grade: zNullable(zStr()),
    bunkerPort: zNullable(zStr()),
    tankToWakeCo2Factor: zNullable(zNum()),
});
export const BunkerReport = zObj({
    id: zNum(),
    plantId: zNum(),
    data: BunkerReportEntry,
    timestamp: zStr(),
});
export const BunkerReports = zArr(BunkerReport);
export const BunkerReportSaveNewArgs = zObj({
    plantId: zNum(),
    data: BunkerReportEntry,
});
export const BunkerReportId = zNum();
export const BunkerReportOperationOk = z.object({});
export const BunkerReportSaveExistingArgs = zObj({
    id: zNum(),
    data: BunkerReportEntry,
});
export const BunkerReportDeleteArgs = zObj({
    id: zNum(),
});
//# sourceMappingURL=bunkerReport.js.map